import './card-category-link.scss'

import { Link } from 'gatsby'
import _ from 'lodash'
import React from 'react'

const CategoryLink = ({ mainCategory, subCategory, i18n, onClick, type }) => {
  let mainCatTitle = _.get(mainCategory, 'name', '')
  mainCatTitle =
    mainCatTitle === 'NFT Stories' ? 'NFT Deep Dives' : mainCatTitle

  return (
    <>
      <Link
        state={{ filter: null }}
        to={
          i18n.language === 'en'
            ? `/${_.get(mainCategory, 'url', '')}`
            : `/${i18n.language}/${_.get(mainCategory, 'url', '')}`
        }
      >
        <span
          onClick={() => {
            let filterState = {}
            filterState[type] = null
            onClick(filterState)
          }}
        >
          {mainCatTitle}
        </span>
      </Link>
      {' / '}
      <Link
        state={{ filter: _.get(subCategory, 'description', '') }}
        to={
          i18n.language === 'en'
            ? `/${_.get(mainCategory, 'url', '')}`
            : `/${i18n.language}/${_.get(mainCategory, 'url', '')}`
        }
      >
        <span>{_.get(subCategory, 'name', '')}</span>
      </Link>
    </>
  )
}

export const CardCategoryLink = ({
  mainCategory,
  subCategory,
  minicard,
  date,
  i18n,
  onClick,
  type,
}) => {
  return (
    <>
      <div className="card-category show-tablet">
        <p>
          <CategoryLink
            mainCategory={mainCategory}
            subCategory={subCategory}
            i18n={i18n}
            onClick={onClick}
            type={type}
          />
          {!minicard && ` - ${date}`}
        </p>
        <p>{minicard && `${date}`}</p>
      </div>
      <div className="card-category show-mobile">
        <p>
          <CategoryLink
            mainCategory={mainCategory}
            subCategory={subCategory}
            i18n={i18n}
          />
        </p>
        <p>{`${date}`}</p>
      </div>
    </>
  )
}
